<div class="questionary-actions">
  @if (questionnaire && questionnaire.documentUploadMessage) {
    <p>{{ questionnaire.documentUploadMessage }}</p>
  }
  <div class="center-container">
    <div class="action-btn-lg primary upload">
      <span class="text">
        upload document
        @if (uploadProgres) {
          <span>{{ uploadProgres }} %</span>
        }
      </span>
      <span class="icon"><ods-icon variant="upload"></ods-icon></span>
      <input (change)="uploadFile($event)" #uploadBtn type="file" class="upload-hidden" aria-describedby="uploadHelp" />
      <span class="explanatory">Document must be in a JPG, JPEG, PNG, or PDF format and cannot exceed 10MB.</span>
      @if (isError) {
        <div class="error">
          <h3>File type or size is wrong.</h3>
        </div>
      }
    </div>

    <ods-button variant="primary" (click)="goHome()">GO BACK HOME</ods-button>
  </div>
</div>
